import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';

export default function ChatsFormatTexts({ messageText }: { messageText: string }) {
    let trio = messageText.slice(0, 3);

    if (['htt', 'www'].includes(trio.toLowerCase())) {
        return (
            <Link className='min-w-[71px]'
                style={{
                    background: 'none',
                    border: "none",
                    color: '#00008B'
                }}
                href={messageText.startsWith('http') ? messageText : `http://${messageText}`} target="_blank" rel="noopener noreferrer">
                {messageText}
            </Link>
        );
    } else {
        return (
            <Typography className='min-w-[71px]' variant="body1" component="span">
                {messageText}
            </Typography>
        );
    }
}